import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "../assets/rentResale.module.css";
import Loader from "../components/Loader";

const RentResale = () => {
  const { rentId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rentData, setRentData] = useState(null);
  const [formData, setFormData] = useState({
    resale_date: "",
    resale_reason: "",
    notes: "",
  });

  useEffect(() => {
    loadRentData();
  }, [rentId]);

  const loadRentData = async () => {
    try {
      setLoading(true);
      const mockData = {
        rent: {
          id: rentId,
          unique_guardian_number: "DECIMOZYHQORS",
          guardianName: "Alex South",
          roomName: "Room 1",
          propertyName: "44 Plummer Road",
          date_start: "25/06/2017",
          date_end: "31/12/2023",
        },
        property: {
          id: 1,
          property_id: "PROP001",
          name: "44 Plummer Road",
          status_text: "Active",
          address_1: "44 Plummer Road",
          postcode: "SW1A 1AA",
        },
        room: {
          id: 1,
          name: "Room 1",
          price: 500.0,
        },
      };

      setRentData(mockData);
    } catch (err) {
      console.error("Error loading rent data:", err);
      setError("Failed to load rent data");
      toast.error("Failed to load rent data");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("Submitting resale data:", formData);

      toast.success("Rent resale processed successfully");
      navigate("/rents/after-date-end");
    } catch (err) {
      console.error("Error processing resale:", err);
      toast.error("Failed to process resale");
    }
  };

  const handleCancel = () => {
    navigate("/rents/after-date-end");
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className={styles["rent-resale-container"]}>
        <div className={styles["rent-resale-error"]}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div className={styles["rent-resale-container"]}>
      {/* <div className="breadcrumb-row">
        <span
          className="breadcrumb-main"
          style={{ fontWeight: 400, fontSize: "14px", color: "black" }}
        >
          Dashboard
        </span>
        <span
          className="breadcrumb-main"
          style={{ fontWeight: 400, fontSize: "14px", color: "black" }}
        >
          / Placed guardians after date end
        </span>
        <div
          style={{ background: "#30C693", fontWeight: 400, fontSize: "14px" }}
        >
          <span className="breadcrumb-sep">/</span>
          <span className="breadcrumb-properties">Resale</span>
        </div>
      </div> */}

      <div className="breadcrumb-row">
        <span
          className="breadcrumb-main"
          style={{ fontWeight: 400, fontSize: "14px", color: "black" }}
        >
          <a href="/dashboard">Dashboard</a>
        </span>
        <span
          className="breadcrumb-main"
          style={{ fontWeight: 400, fontSize: "14px", color: "black" }}
        >
          <a href="/rents/after-date-end">/ Placed guardians after date end</a>
        </span>
        <div
          style={{ background: "#30C693", fontWeight: 400, fontSize: "14px" }}
        >
          <span className="breadcrumb-sep">/</span>
          <span className="breadcrumb-properties">Resale</span>
        </div>
      </div>

      <h1 className={styles["rent-resale-title"]}>Rent Resale</h1>

      <div className={styles["rent-resale-section"]}>
        <h2 className={styles["rent-resale-section-title"]}>
          Guardian Overview
        </h2>
        <div className={styles["rent-resale-overview"]}>
          <div className={styles["rent-resale-overview-item"]}>
            <label>UGD:</label>
            <span>{rentData?.rent?.unique_guardian_number}</span>
          </div>
          <div className={styles["rent-resale-overview-item"]}>
            <label>Guardian:</label>
            <span>{rentData?.rent?.guardianName}</span>
          </div>
          <div className={styles["rent-resale-overview-item"]}>
            <label>Room:</label>
            <span>{rentData?.rent?.roomName}</span>
          </div>
          <div className={styles["rent-resale-overview-item"]}>
            <label>Property:</label>
            <span>{rentData?.rent?.propertyName}</span>
          </div>
          <div className={styles["rent-resale-overview-item"]}>
            <label>Start Date:</label>
            <span>{rentData?.rent?.date_start}</span>
          </div>
          <div className={styles["rent-resale-overview-item"]}>
            <label>End Date:</label>
            <span>{rentData?.rent?.date_end}</span>
          </div>
        </div>
      </div>

      <div className={styles["rent-resale-section"]}>
        <h2 className={styles["rent-resale-section-title"]}>
          Resale Information
        </h2>
        <form onSubmit={handleSubmit} className={styles["rent-resale-form"]}>
          <div className={styles["rent-resale-form-group"]}>
            <label htmlFor="resale_date">Resale Date *</label>
            <input
              type="date"
              id="resale_date"
              name="resale_date"
              value={formData.resale_date}
              onChange={handleInputChange}
              required
              className={styles["rent-resale-input"]}
            />
          </div>

          <div className={styles["rent-resale-form-group"]}>
            <label htmlFor="resale_reason">Resale Reason *</label>
            <select
              id="resale_reason"
              name="resale_reason"
              value={formData.resale_reason}
              onChange={handleInputChange}
              required
              className={styles["rent-resale-select"]}
            >
              <option value="">Select a reason</option>
              <option value="guardian_left">Guardian Left</option>
              <option value="contract_ended">Contract Ended</option>
              <option value="property_sold">Property Sold</option>
              <option value="renovation">Renovation</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className={styles["rent-resale-form-group"]}>
            <label htmlFor="notes">Notes</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              rows="4"
              className={styles["rent-resale-textarea"]}
              placeholder="Additional notes about the resale..."
            />
          </div>

          <div className={styles["rent-resale-actions"]}>
            <button
              type="submit"
              className={`${styles["rent-resale-btn"]} ${styles["rent-resale-btn-primary"]}`}
            >
              Process Resale
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className={`${styles["rent-resale-btn"]} ${styles["rent-resale-btn-secondary"]}`}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RentResale;
